// extracted by mini-css-extract-plugin
export default {"replace":"replace-KiLJ1"};